abstract class IPassportAttendeeSSODAO {
    abstract getFusionPassportIdentityProviders(): Promise<FusionIdentityProviderResponseDAO[]>;
    abstract getPassportIdentityProviders(requestParams: IPassportAttendeeSSORequestParams): Promise<IdentityProviderResponseDAO[]>;
    abstract updatePassportIdentityProvider(requestParams: IdentityProviderRequestDAO): Promise<IdentityProviderResponseDAO>;
    abstract createBulkPassportIdentityProviders(requestParams: IdentityProviderMappingsResponse): Promise<IdentityProviderMappingsResponse>;
    abstract getEventPassportIdentityProviders(requestParams: {accountId: number; eventId: number}): Promise<IEventIdentityProviderMapping[]>;
    abstract createEventPassportIdentityProvider(requestParams: IEventIdentityProviderRequestDAO): Promise<IEventIdentityProviderMapping>;
    abstract updateEventPassportIdentityProvider(requestParams: IEventIdentityProviderRequestDAO): Promise<IEventIdentityProviderMapping>;
}

type IPassportAttendeeSSORequestParams = {
    accountId: number;
};

interface IdentityProviderResponseDAO extends IdentityProviderMapping {
  id: number;
};

interface IdentityProviderMapping {
  fusionAuthIdpId: string;
  fusionAuthIdpName: string;
  enabled: boolean;
  enabledForAllEvents: boolean;
  managedDomains: string[];
}

interface FusionIdentityProviderResponseDAO {
  id: string;
  name: string;
  type: string;
  domains: string[];
  enabled: boolean;
  enabledForAllEvents: boolean;
  applicationConfiguration: {
    createRegistration: boolean;
    enabled: boolean;
  };
}

interface IdentityProviderMappingsResponse {
    mappings: IdentityProviderMapping[];
    accountId: number;
}

interface IdentityProviderRequestDAO extends IdentityProviderResponseDAO {
    accountId: number;
}


interface IEventIdentityProviderMapping {
  enabled: boolean;
  allowedIdpIds: string[];
  accountId?: number;
  id?: number;
}

interface IEventIdentityProviderRequestDAO extends IEventIdentityProviderMapping {
    eventId: number;
}

export {
    IPassportAttendeeSSODAO,
    IPassportAttendeeSSORequestParams,
    IdentityProviderResponseDAO,
    IdentityProviderRequestDAO,
    FusionIdentityProviderResponseDAO,
    IdentityProviderMappingsResponse,
    IdentityProviderMapping,
    IEventIdentityProviderRequestDAO,
    IEventIdentityProviderMapping
};